/**
 * Created by sombra-41 on 29.11.16.
 */
(() => {
	angular
		.module('main')
		.controller('ChangeLoginController', ChangeLoginController);

	ChangeLoginController.$inject = [
		'$scope',
		'$rootScope',
		'$location',
		'$http',
		'$timeout',
		'$routeParams',
		'messageService',
		'accountService'
	];

	function ChangeLoginController(
		$scope,
		$rootScope,
		$location,
		$http,
		$timeout,
		$routeParams,
		messageService,
		accountService
	) {
		$scope.$on('$viewContentLoaded', () => {
			confirmChange();
		});

		function showSuccessChangeEmail() {
			messageService.showToaster('s_0', 'changeLogin');
		}

		function confirmChange() {
			const url = `/public/rest/user/change/login/confirm/${
				$routeParams.token
			}`;

			$http.get(url).then(
				() => {
					showSuccessChangeEmail();

					$timeout(() => {
						try {
							accountService.logoutWeb();
						} catch (e) {
							$location.path('login');
						}
					}, 400);
				},
				result => {
					if (result.status === 409) {
						messageService.showToaster('e_0', 'changeLogin');
						$rootScope.error = true;
						$rootScope.error_message =
							'Damn! The link to update your email address has already been used.';
					} else {
						$location.path('login');
					}
				}
			);
		}
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/login/changeLoginController.js